




































import constants from "../../config/constants";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Photo as PhotoInterface } from "../../services/settings/entities/photo.interface";

@Component
export default class Photo extends Vue {
  @Prop() photo!: PhotoInterface;
  @Prop() totalPhotos!: number;
  loadingDelete = false;
  get isVideo() {
    return (
      !!this.photo.photoKind &&
      this.photo.photoKind == constants.PHOTO_KIND.VIDEO
    );
  }
  private deletePhoto(): void {
    this.loadingDelete = true;
    this.$store
      .dispatch("settings/deletePhoto", {
        photoID: this.photo.photoID,
        photoURL: this.photo.photoURL,
        photoKind: this.photo.photoKind,
      })
      .then((response: boolean) => {
        if (response) {
          this.$emit("successDelete");
        } else {
          this.$emit("errorDelete");
        }
        this.$store.dispatch("settings/getPhotos");
      });
  }
}
